export const GET_BLOG_LIST_SUCCESS = 'GET_BLOG_LIST_SUCCESS';
export const GET_BLOG_LIST_FAIL = 'GET_BLOG_LIST_FAIL';

export const GET_AUTHOR_BLOG_LIST_SUCCESS = 'GET_AUTHOR_BLOG_LIST_SUCCESS';
export const GET_AUTHOR_BLOG_LIST_FAIL = 'GET_AUTHOR_BLOG_LIST_FAIL';

export const GET_BLOG_LIST_CATEGORIES_SUCCESS = 'GET_BLOG_LIST_CATEGORIES_SUCCESS';
export const GET_BLOG_LIST_CATEGORIES_FAIL = 'GET_BLOG_LIST_CATEGORIES_FAIL';

export const GET_BLOG_SUCCESS = 'GET_BLOG_SUCCESS';
export const GET_BLOG_FAIL = 'GET_BLOG_FAIL';

export const GET_SEARCH_BLOG_SUCCESS = 'GET_SEARCH_BLOG_SUCCESS';
export const GET_SEARCH_BLOG_FAIL = 'GET_SEARCH_BLOG_FAIL';